import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';

export interface LoginState {
  authenticated: boolean;
  loading: boolean;
  error: Error | null;
  username: string | null;
  resendToken: string | null;
}

export const initialState: LoginState = {
  authenticated: false,
  loading: false,
  error: null,
  username: null,
  resendToken: null,
};

export const loginReducer = createReducer(
  initialState,
  on(AuthActions.Login, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.LoginSuccess, (state) => ({ ...state, authenticated: true, loading: false, error: null, resendToken: null })),
  on(AuthActions.LoginFail, (state, { error }) => ({
    ...state,
    authenticated: false,
    loading: false,
    error,
  })),
  on(AuthActions.Logout, (state) => {
    return initialState;
  }),
  on(AuthActions.LoginWithMultiFactor, (state, { username, resendToken }) => ({
    ...state,
    username,
    resendToken,
    loading: false,
    error: null,
  })),
  // add changes.resendToken is existing or set it to null if not provided
  on(AuthActions.SetResendToken, (state, { resendToken }) => ({
    ...state,
    resendToken,
  }))
);
